<template>
    <ResourceAttachSelect
        v-if="!isAddingNewImage"
        title="Add Existing Image"
        label="Choose existing image resource"
        select-id="existing_image"
        :options="imageOptions"
        placeholder="Search for image by keyword or title"
        :show-toggle-link="true"
        toggle-link-text="Add New Image"
        @toggle-link="toggleMode"
        @cancel="handleCancel"
        @attach="$emit('attach', $event)"
    />

    <ResourceCreateForm
        v-else
        title="Add New Image"
        type="interactive_images"
        :lesson-id="lessonId"
        toggle-link-text="Pick Existing Image"
        upload-label="Upload Zip File"
        empty-file-text="Select a zip file to upload"
        accept=".zip"
        save-button-text="Save Image"
        title-id="new_image_title"
        slug-id="new_image_slug"
        @cancel="handleCancel"
        @toggle-link="toggleMode"
        @create="$emit('create', $event)"
    />
</template>

<script lang="ts">
import axios from "axios";
import ResourceAttachSelect from "./ResourceAttachSelect.vue";
import ResourceCreateForm from "./ResourceCreateForm.vue";

export default {
    components: {
        ResourceAttachSelect,
        ResourceCreateForm,
    },
    props: {
        lessonId: {
            type: [String, Number],
            required: true,
        },
    },
    data(): any {
        return {
            isAddingNewImage: false,
            imageOptions: [],
        };
    },
    methods: {
        async getImageOptions() {
            try {
                const response = await axios.get(
                    "/api/learn/resources/interactiveImages/options"
                );

                this.imageOptions = response.data ?? [];
            } catch {
                this.imageOptions = [];
            }
        },
        toggleMode() {
            this.isAddingNewImage = !this.isAddingNewImage;
        },
        handleCancel() {
            this.isAddingNewImage = false;
            this.$emit("cancel");
        },
    },
    mounted() {
        this.getImageOptions();
    },
};
</script>
